import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

export default function BillingCancelPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Clear pendingCheckout flag when user reaches cancel page
    if (typeof window !== 'undefined') {
      localStorage.removeItem('pendingCheckout');
    }
  }, []);

  const sessionId = searchParams.get('session_id');

  return (
    <div className="min-h-screen bg-muted py-8 px-4">
      <div className="max-w-md mx-auto">
        <Card>
          <CardHeader className="text-center">
            <XCircle className="h-12 w-12 mx-auto mb-4 text-orange-600" />
            <CardTitle className="text-2xl text-orange-600">Payment Cancelled</CardTitle>
            <CardDescription>
              Your payment was cancelled. No charges were made to your account.
            </CardDescription>
          </CardHeader>
          
          <CardContent className="space-y-4">
            <Alert className="border-orange-200 bg-orange-50">
              <XCircle className="h-4 w-4 text-orange-600" />
              <AlertDescription className="text-orange-800">
                You can try again anytime or choose a different plan that better suits your needs.
              </AlertDescription>
            </Alert>

            {sessionId && (
              <div className="text-sm text-muted-foreground">
                <p>Session ID: {sessionId}</p>
              </div>
            )}

            <div className="space-y-2">
              <Button 
                onClick={() => navigate('/affiliate/signup')} 
                className="w-full"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Plans
              </Button>
              <Button 
                variant="outline"
                onClick={() => navigate('/dashboard/billing')} 
                className="w-full"
              >
                View Billing Options
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}